export const WORLD_REPORT_REASON_VALUES = [
  'hate-speech',
  'bullying-or-harassment',
  'threats-or-incitement-of-violence',
  'promoting-or-glorifying-self-harm',
  'spam-or-scams',
  'illegal-content',
  'sharing-private-or-personal-information',
  'other',
] as const

export type WorldReportReason = (typeof WORLD_REPORT_REASON_VALUES)[number]
